import React, { PureComponent, Fragment } from 'react';
import { Container, Col, Row } from 'bootstrap-4-react';
import Form from 'react-bootstrap/Form';
import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Mousewheel, EffectFade, Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";



import constructionVideo from "./../../../assets/img/Marquis-Elegance.mp4";




SwiperCore.use([Mousewheel, EffectFade, Pagination]);
class PropertiesConstructionElegance extends PureComponent {


    play_video() {

    }

    render() {

        return (
            <Fragment>
                <Container fluid className="secSpacing construction-sec">
                    <Row className="d-flex justify-content-center">
                        <Col lg={1}></Col>

                        <Col lg={11}>
                            <h2 className="text-center canelaMedium secHeading margin-top-2 darkBlue" data-aos='fade-up'>
                                CONSTRUCTION UPDATES
                            </h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={1}></Col>

                        <Col lg={11}>
                            <div className="construction-swiper-div">
                                <div className="constructionSwiper">

                                    <div className="row flex-center">
                                        <div className="col-md-4">
                                            <video autoPlay
                                                muted
                                                loop
                                                playsInline
                                                style={{ width: "100%", height: "auto", display: "block" }} className="object-cover" controls>
                                                <source src={constructionVideo} type="video/mp4" ref={this.const_video} />
                                            </video>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                    <Row className="d-flex justify-content-center">
                        <Col lg={1}></Col>

                        <Col lg={11}>
                            <h2 className="text-center canelaMedium small-head darkBlue">
                                May, 2025
                            </h2>

                        </Col>

                    </Row>

                </Container>

            </Fragment>
        )
    }
}

export default PropertiesConstructionElegance